import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-confirmar-entrada',
  template: `
    <div style="text-align:center; margin-top: 100px; font-family: Arial;">
      <div *ngIf="loading">⏳ Procesando confirmación...</div>
      <div *ngIf="success" style="color: green; font-size: 24px;">✅ Orden confirmada exitosamente.</div>
      <div *ngIf="error" style="color: red; font-size: 18px;">❌ {{ errorMessage }}</div>
    </div>
  `
})
export class ConfirmarEntradaComponent implements OnInit {
  loading = true;
  success = false;
  error = false;
  errorMessage = '';

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  ngOnInit() {
    const token = this.route.snapshot.paramMap.get('token');
    this.http.get(`${environment.apiUrl}/entradas/confirmar/${token}`, { responseType: 'text' })
      .subscribe({
        next: () => {
          this.loading = false;
          this.success = true;
        },
        error: (err) => {
          this.loading = false;
          this.error = true;
          this.errorMessage = 'No se pudo confirmar la orden. Intenta de nuevo.';
        }
      });
  }
}